import React, { useEffect, useState } from 'react'
import RatingMilestoneTable from '../Rating/RatingMilestoneTable'
import useCustomToast from '../../../hooks/useCustomToast'
import RatingService from '../../../services/rating.service'
import { FiX } from 'react-icons/fi'

function RatingMilestonePopup({ type, modal, setShow, studentId }: { type: string, modal: string, setShow: any, studentId: string }) {
    const [milestones, setMilestones] = useState<any>([])
    const customToast = useCustomToast()
    const getRatingMilestones = async () => {
        if (!type) return customToast("Please select rating type", "error")
        if (!modal) return customToast("Please select model type", "error")

        const result: any = await RatingService.getRatings(type, modal, studentId)
        if (result?.results?.length) {
            setMilestones(result?.results?.sort((a: any, b: any) => b?.completed - a.completed))
        }
    }
    useEffect(() => {
        getRatingMilestones()
    }, [])

    return (
        <div className='milestones_model'>
            <RatingMilestoneTable milestones={milestones} />
            <div className="close" onClick={() => setShow(false)}><FiX /></div>
        </div>
    )
}

export default RatingMilestonePopup